import { cn } from '@/lib/utils';

type AppFooterProps = {
  className?: string;
};

/** Single compact powered-by line for VEE Connector. */
export function AppFooter({ className }: AppFooterProps) {
  return (
    <footer
      className={cn(
        'flex shrink-0 justify-center border-t border-border bg-card/80 px-3 py-2',
        className
      )}
    >
      <p className="max-w-fit whitespace-nowrap text-[11px] leading-none text-muted-foreground">
        VEE Connector · Powered by{' '}
        <a
          href="https://voiceracx.ai/"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-primary underline-offset-2 hover:underline"
        >
          VOICERAcx.ai
        </a>{' '}
        © 2026
      </p>
    </footer>
  );
}
